import Component from '../abstracts/Component';
import Handlebars from 'Vendor/handlebars/dist/handlebars.js';
import HandleBarUtils from "../utils/HandleBarUtils";
import {doAjax} from '../utils/ajaxUtil';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import _ from "lodash";

export default class StoreLocatorComponent extends Component {
  get SELECTORS() {
    return {
      inputSearch: '#ma_sl-search-input',
      inputSearchContainer: '[data-store-search-input]',
      clearButton: '.ma_sl-search-blank-btn',
      searchButton: '#ma_my-geo',
      searchResults: '.ma_sl-search-results',
      mapContainer: '#map-container',
      storeCounter: '.counter',
      storeTemplate: '#template-store',
      filterContainer: '.ma_sl-filters',
      featuresFilters: '.custom-filter',
      filterLabel: '.custom-filter-label',
      resultContainer: '#results-list-container',
      storeItem: '.js-store-item',
      noResultsContainer: '.no-results',
      filtersBtn: '[data-filters-button]',
      filtersBox: '[data-filters-box]',
      filtersLayerClose: '.close-panel, .apply-filters',
      filtersRemove: '.remove-filters',
      filtersCollection: '[data-filter-collection] input',
      prefilter: 'input[data-id="prefilter"]'
    }
  }

  get CLASSES() {
    return {
      selected: 'selected',
      checked: 'checked',
      hidden: '--hidden',
      show: 'show',
      open: 'is-open'
    }
  }

  constructor(htmlEl) {
    super();

    this.inputSearch = htmlEl.querySelector(this.SELECTORS.inputSearch);
    this.inputSearchContainer = htmlEl.querySelector(this.SELECTORS.inputSearchContainer);
    this.clearButton = htmlEl.querySelector(this.SELECTORS.clearButton);
    this.searchButton = htmlEl.querySelector(this.SELECTORS.searchButton);
    this.searchResults = htmlEl.querySelector(this.SELECTORS.searchResults);
    this.mapContainer = htmlEl.querySelector(this.SELECTORS.mapContainer);
    this.storeCounter = htmlEl.querySelectorAll(this.SELECTORS.storeCounter);
    this.storeTemplate = htmlEl.querySelector(this.SELECTORS.storeTemplate);
    this.filterContainer = htmlEl.querySelector(this.SELECTORS.filterContainer);
    this.featuresFilters = htmlEl.querySelectorAll(this.SELECTORS.featuresFilters);
    this.resultContainer = htmlEl.querySelector(this.SELECTORS.resultContainer);
    this.noResultsContainer = htmlEl.querySelector(this.SELECTORS.noResultsContainer);
    this.filtersBtn = htmlEl.querySelectorAll(this.SELECTORS.filtersBtn);
    this.prefilter = htmlEl.querySelector(this.SELECTORS.prefilter);
    this.TemplateCompile = this.ParsedTemplate;

    this.contextPath = document.getElementsByTagName('HTML')[0].getAttribute("data-context");
    this.version = document.documentElement.dataset.version;

    // initialize all "global" variables
    this.googleApiKey;
    this.googleLanguage;
    this.country = $("#country").val();
    this.countryIsoCode = $("#countryIsoCode").val();
    this.map;
    this.markers = [];
    this.params = (this.prefilter !== null && this.prefilter.value !== '') ? [this.prefilter.value] : [];
    this.center;
    this.viewport;
    this.token;

    // C&C check
    this.inCart = document.body.classList.contains('t-cart') || document.body.classList.contains('t-cart-v2');

    // init custom helper
    HandleBarUtils.equalUtil();
  }

  /**
   * Function to inject content in template
   */
  get ParsedTemplate() {
    return Handlebars.compile(this.storeTemplate.innerHTML);
  }

  /**
   * Function to load and register external libraries
   * @returns {Promise} - a promise in order to use callback fns
   */
  async loadLibraries() {
    return new Promise((resolve, reject) => {
      // get data
      this.googleApiKey = $("#googleApiKey").val();
      this.googleLanguage = $("#googleLanguage").val();
      const apiUrl = `https://maps.googleapis.com/maps/api/js?v=quarterly&key=${this.googleApiKey}&libraries=places,geometry&language=${this.googleLanguage}&v=beta`;

      // load google maps script
      this.moduleLoader.loadExternalScript(apiUrl).then(async () => {
        window.GEO_JSON = {};
        // load google maps libraries
        const { Map } = await google.maps.importLibrary('maps');
        this.Map = Map;

        const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
        this.AdvancedMarkerElement = AdvancedMarkerElement;

        const { Geocoder } = await google.maps.importLibrary('geocoding');
        this.Geocoder = Geocoder;

        const { AutocompleteSessionToken, AutocompleteSuggestion } = await google.maps.importLibrary('places');
        this.AutocompleteSessionToken = AutocompleteSessionToken;
        this.AutocompleteSuggestion = AutocompleteSuggestion;
        resolve();
      }).catch(error => {
        reject(error);
      });
    });
  }

  /**
   * Function to init map with styles and options
   */
  async initMap() {
    // get initial center and bounds based on country
    const token = new this.AutocompleteSessionToken();
    // geocoder
    const geocoder = new this.Geocoder();
    this.geocoder = geocoder;
    // fill request input with country value
    let request = { input: this.country };
    request.sessionToken = token;
    // save token for future requests
    this.token = token;
    // get suggestions
    const { suggestions } = await this.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
    // get first result
    const toPlace = suggestions[0].placePrediction.toPlace();
    // fetch useful fields
    await toPlace.fetchFields({
      fields: ['location', 'viewport', 'formattedAddress']
    });
    // set viewport
    this.viewport = toPlace.viewport;
    // set bounds
    const neBounds = toPlace.viewport.getNorthEast();
    const swBounds = toPlace.viewport.getSouthWest();
    this.bounds = {
      northEast: { lat: neBounds.lat(), lng: neBounds.lng() },
      southWest: { lat: swBounds.lat(), lng: swBounds.lng() }
    }
    // set center
    const lat = toPlace.location.lat();
    const lng = toPlace.location.lng();
    this.center = {lat, lng}

    // map options
    const options = {
      disableDefaultUI: true,
      scaleControl: true,
      fullscreenControl: false,
      zoomControl: !(this.isMobile()),
      gestureHandling: 'cooperative',
      mapId: '2fdcac20d6c3453b',
      center: this.center,
      zoom: 5
    };

    // Create map
    this.map = new this.Map(this.mapContainer, options);
    // this.map.fitBounds(toPlace.viewport);
    // add event listener to reload stores when map's bounds are changed (zoom, drag )
    this.map.addListener('dragend', () => {
      const viewport = this.map.getBounds();
      const location = this.map.getCenter();
      this.searchStores(viewport, location);
    });
    this.map.addListener('zoom_changed', () => {
      const viewport = this.map.getBounds();
      const location = this.map.getCenter();
      this.searchStores(viewport, location);
    });
    // Load stores
    this.loadStores();
  }

  /**
   * Function to detect mobile or desktop
   * @returns {boolean}
   */
  isMobile() {
    const mq = window.matchMedia('(max-width: 1023px)');
    const isMobile = mq.matches;
    return isMobile;
  }

  /**
   * Function to load stores data and create markers and clusters
   * @param {Object} inputData - data object to use in ajax call (optional)
   */
  loadStores(inputData = null) {
    const url = this.contextPath + '/store-locator';
    // loader
    document.body.classList.add('loading');
    let data = inputData ? inputData : {
      listJson: true,
      withoutRadius: false,
      country: this.countryIsoCode
    };
    // if there are filters, include them in data
    if (this.params.length) {
      data.features = [...this.params];
    }
    doAjax({
      url: url,
      data: data,
      traditional: true,
      success: (resp) => {
        // in any case, clean old markers
        if (!this.inCart) this.clearOldMarkers();
        // set number of results
        this.storeCounter.forEach(store => {
          store.innerHTML = String(resp.features.length);
        });
        // if we have at least one store, proceed
        if (resp.features.length) {
          // create marker clusterer
          if (!this.inCart) {
            resp.features.forEach(feature => {
              this.createMarker(feature);
            });

            const markers = this.markers;
            const map = this.map;

            this.markerClusterer = new MarkerClusterer({
              markers: markers,
              map: map,
              renderer: {
                render: ({
                           count,
                           position
                         }) => {
                  // Create a custom cluster HTML element to be used with an AdvancedMarker
                  const el = document.createElement("div");
                  // set class
                  el.className = 'cluster';
                  // Set content
                  el.textContent = String(count);

                  return new this.AdvancedMarkerElement({
                    position,
                    content: el,
                    title: 'AdvancedMarkerElement Cluster'
                  })
                }
              },
              algorithmOptions: { radius: 120 }
            });
          }

          // create store items template
          this.createStoreItems(resp.features);
          // bind event listeners to store items
          this.addListenerToStoreItems();
        } else {
          // clear store items
          this.clearStoreItems();
        }
        document.body.classList.remove('loading');
      }
    })
  }

  /**
   * Function to create custom pin element and marker attached to the map.
   * It also adds an event listener to the marker in order to toggle highlight of it.
   * @param {Object} feature - object that contains all store data
   */
  createMarker(feature) {
    // Create svg for pin. Images are handled via scss
    const pinImg = document.createElement("img");
    pinImg.id = feature.properties.name;
    pinImg.className = 'marella-marker';

    // Create marker
    const marker = new this.AdvancedMarkerElement({
      map: this.map,
      position: { lat: feature.geometry.coordinates[1], lng: feature.geometry.coordinates[0] },
      title: feature.properties.displayName,
      content: pinImg
    });
    // add listener to marker
    marker.addListener('gmp-click', () => {
      this.toggleHighlightMarker(marker);
    })
    this.markers.push(marker);
  }

  /**
   *
   * @param {Array} features - array of object that contains all stores data
   */
  createStoreItems(features) {
    // show results elements
    this.noResultsContainer.classList.remove(this.CLASSES.show);
    this.resultContainer.classList.remove(this.CLASSES.hidden);
    this.filterContainer ? this.filterContainer.classList.remove(this.CLASSES.hidden) : '';

    let storeLoaded = [];
    if (features && features.length) {
      // for every store, create a store item from template
      features.forEach(feature => {
        storeLoaded.push(this.TemplateCompile(feature.properties));
      });
      // inject content to HTML
      this.resultContainer.innerHTML = storeLoaded.join('');
    }
  }

  /**
   * Function to clean all old markers
   */
  clearOldMarkers() {
    // remove markers from map
    this.markers.forEach(marker => {
      marker.map = null;
    });
    this.markers = [];
    // if cluster is active, clean it
    if (this.markerClusterer) this.markerClusterer.clearMarkers();
  }

  /**
   * Function to clear all results items and close results container
   */
  clearStoreItems() {
    // hide results elements
    this.resultContainer.innerHTML = '';
    this.noResultsContainer.classList.add(this.CLASSES.show);
    this.resultContainer.classList.add(this.CLASSES.hidden);
    // this.filterContainer.classList.add(this.CLASSES.hidden);
  }

  /**
   * Function to toggle highlight for both marker and store item
   * @param {Object} marker - AdvancedMarkerElement object
   */
  toggleHighlightMarker(marker) {
    // check if marker is already selected
    if (marker.content.classList.contains(this.CLASSES.selected)) {
      // remove selected class for marker
      marker.content.classList.remove(this.CLASSES.selected);
      // deselect store item
      this.selectStoreItem(marker, false);
    } else {
      // remove selected class from all markers
      this.markers.forEach(marker => {
        marker.content.classList.remove(this.CLASSES.selected);
      });
      // add selected class to clicked marker
      marker.content.classList.add(this.CLASSES.selected);
      // select store item
      this.selectStoreItem(marker, true);
    }
  }

  /**
   * Function to select or deselect store item
   * @param {Object} marker - AdvancedMarkerElement object
   * @param {boolean} select - bool that indicates if we have to select or deselect
   */
  selectStoreItem(marker, select) {
    // get all store items
    let storeItems = this.resultContainer.querySelectorAll('[data-store-id]');
    // get store item in question
    let storeItem = this.resultContainer.querySelector(`[data-store-id="${marker.content.id}"]`);
    if (storeItem) {
      if (select) {
        // remove selected class from all store items
        storeItems.forEach(item => {
          item.classList.remove(this.CLASSES.selected);
        });
        // add selected class to store item
        storeItem.classList.add(this.CLASSES.selected);
        storeItem.scrollIntoView({behavior: 'smooth', block: 'nearest'});
      } else {
        // remove selected class from store item
        storeItem.classList.remove(this.CLASSES.selected);
      }
    }
  }

  /**
   * Function to toggle marker selection
   * @param {Object} storeItem - HTML store item
   */
  selectMarker(storeItem) {
    // find marker element
    const marker = this.markers.find(marker => marker.content.id === storeItem.dataset.storeId);
    // toggle highlight marker
    this.toggleHighlightMarker(marker);
  }

  /**
   * Function to toggle selection of filter item
   * @param {HTMLElement} feature - HTML element of filter in question
   */
  handleFilterSelection(feature) {
    if (feature.classList.contains(this.CLASSES.checked)) {
      // deselect filter
      feature.classList.remove(this.CLASSES.checked);
      // remove filter
      this.removeFilterParam(feature);
    } else {
      // select filter
      feature.classList.add(this.CLASSES.checked);
      // add filter
      this.addFilterParam(feature);
    }
  }

  /**
   * Function to add a filter
   * @param {HTMLElement} feature - HTML element of filter in question
   */
  addFilterParam(feature) {
    // add filter
    this.params.push(feature.firstElementChild.value);
    // reload stores
    this.loadStores();
  }

  /**
   * Function to remove a filter
   * @param {HTMLElement} feature - HTML element of filter in question
   */
  removeFilterParam(feature) {
    // remove filter
    this.params = this.params.filter(p => p != feature.firstElementChild.value);
    // reload stores
    this.loadStores();
  }

  /**
   * Function to add event listener to store items
   */
  addListenerToStoreItems() {
    // get store items
    const storeItems = this.resultContainer.querySelectorAll(this.SELECTORS.storeItem);
    if (storeItems && storeItems.length && !this.inCart) {
      // for each store, add a click event listener that toggle marker selection
      storeItems.forEach(storeItem => {
        storeItem.addEventListener('click', () => this.selectMarker(storeItem));
      });
    };

    if (this.inCart) {
      this.$emit(this.$customEvents.O2O.ccStoresShowResults);
    }
  }

  /**
   * Function to simulate Autocomplete, interrogating Google Maps suggestion service
   * @param {String} text - input text to be searched
   */
  async onSearchInput(event, ctx) {
    event.preventDefault();
    const text = event.target.value;
    let executeSearch = false;
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      const activeEl = document.activeElement;
      if (activeEl.classList.contains('ma_sl-search-results__item')) {
        activeEl.nextElementSibling.focus();
      } else {
        this.searchResults.children[0].focus();
      }
      return;
    } else if (event.key === 'Enter') {
      executeSearch = true;
    }
    // clear previous results
    this.manageResultsLayer(false, true);
    if (text) {
      // create request
      const request = {
        input: text,
        origin: ctx.center,
        sessionToken: ctx.token
      };
      // get suggestions
      const { suggestions } = await ctx.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);
      if (suggestions.length) {
        if (executeSearch) {
          const placePrediction = suggestions[0].placePrediction;
          const place = placePrediction.toPlace();
          // fetch useful fields
          await place.fetchFields({
            fields: ['location', 'viewport', 'formattedAddress', 'displayName']
          });
          ctx.setMapBoundsAndSearchStores(place.viewport, place.location, place.formattedAddress);
          // hide results
          ctx.manageResultsLayer(true, false);
        } else {
          // if results are hidden, show them
          ctx.manageResultsLayer(false, false);
          // for every suggestion create a list item and register event listeners
          for (let suggestion of suggestions) {
            const placePrediction = suggestion.placePrediction;
            const place = placePrediction.toPlace();
            // fetch useful fields
            await place.fetchFields({
              fields: ['location', 'viewport', 'formattedAddress']
            });
            const value = placePrediction.text.toString();
            // if this item is not already present, proceed
            if (!ctx.searchResults.children.namedItem(value)) {
              // create a list element
              const listItem = document.createElement('li');
              // set value and tabindex attributes
              listItem.setAttribute('value', value);
              listItem.setAttribute('tabindex', 0);
              // set class
              listItem.classList.add('ma_sl-search-results__item');
              // create text node
              listItem.appendChild(
                document.createTextNode(value)
              );
              // register event listener to select list item
              listItem.addEventListener('click', () => {
                ctx.onSelectSearchResultItem(listItem);
                ctx.setMapBoundsAndSearchStores(place.viewport, place.location, place.formattedAddress);
              });
              // register event listener to navigate through list items and select one
              listItem.addEventListener('keydown', (e) => {
                e.preventDefault();
                if (e.key === 'ArrowDown') {
                  if (listItem.nextElementSibling) {
                    listItem.nextElementSibling.focus();
                  }
                }
                if (e.key === 'ArrowUp') {
                  if (listItem.previousElementSibling) {
                    listItem.previousElementSibling.focus();
                  }
                }
                if (e.key === 'Enter') {
                  ctx.onSelectSearchResultItem(listItem);
                  ctx.setMapBoundsAndSearchStores(place.viewport, place.location);
                }
              });
              // append list item to results list
              ctx.searchResults.appendChild(listItem);
            }
          }
        }
      } else {
        ctx.manageResultsLayer(true, false);
      }
    } else {
      ctx.manageResultsLayer(true, false);
    }
  }

  /**
   * Function to set value in input based on user's selection
   * @param {HTMLLIElement} listItem - HTML <li> element
   */
  onSelectSearchResultItem(listItem) {
    // set input value
    const value = listItem.getAttribute('value');
    this.inputSearch.value = value;
    // close search results
    this.manageResultsLayer(true, false);

    // refresh token
    const token = new this.AutocompleteSessionToken();
    this.token = token;
  }

  /**
   * Function to set map bounds and search stores in that area
   * @param {LatLngBounds} viewport - object that contains bounds coordinates (Maps class)
   * @param {LatLng} location - object that contains center coordinates (Maps class)
   * @param String formattedAddress - formatted address of position
   */
  setMapBoundsAndSearchStores(viewport, location, formattedAddress = null) {
    // set map bounds
    this.map.fitBounds(viewport);
    // update search input
    if (formattedAddress) {
      // address comes from google current search
      this.inputSearch.value = formattedAddress;
    } else {
      // for geolocation we don't have an address, launch new search to retrieve it
      this.updateSearchInput(location);
    }
    // search stores in new area
    this.searchStores(viewport, location);
  }

  /**
   * Function to search stores inside an area
   * @param {LatLngBounds} viewport - object that contains bounds coordinates (Maps class)
   * @param {LatLng} location - object that contains center coordinates (Maps class)
   */
  searchStores(viewport, location) {
    // set bounds
    const neBounds = viewport.getNorthEast();
    const swBounds = viewport.getSouthWest();
    this.bounds = {
      northEast: { lat: neBounds.lat(), lng: neBounds.lng() },
      southWest: { lat: swBounds.lat(), lng: swBounds.lng() }
    }
    // set center
    const lat = location.lat;
    const lng = location.lng;
    // this.center = {lat, lng};
    // create data object
    // NOTICE: lat and lng should be reversed, but service is working with these values
    // (north should be northEast.lng, east should be northEast.lat, ecc...)
    const data = {
      north: this.bounds.northEast.lat,
      east: this.bounds.northEast.lng,
      south: this.bounds.southWest.lat,
      west: this.bounds.southWest.lng,
      lat: lat,
      lng: lng,
      listJson: true,
      withoutRadius: false
    };
    // load stores
    this.loadStores(data);
  }

  /**
   * Function to bind events related to filtering
   */

  filteringFunctions() {
    // vars
    let ctx = this;
    let filtersBox = document.querySelectorAll(this.SELECTORS.filtersBox);
    // check
    if (filtersBox === null) return false;
    filtersBox.forEach(box => {
      // bind close
      let closeBtns = box.querySelectorAll(ctx.SELECTORS.filtersLayerClose);
      if (closeBtns !== null) {
        closeBtns.forEach(btn => {
          btn.addEventListener('click',(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            box.classList.remove(ctx.CLASSES.open);
          });
        });
      }
      // bind remove
      let removeFilters = box.querySelector(ctx.SELECTORS.filtersRemove);
      if (removeFilters !== null) {
        removeFilters.addEventListener('click',(e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          ctx.clearFilters();
        });
      }
      // collection function
      ctx.filterCollection(box);
    });
  }

  /**
   * Function to remove all filters
   */
  clearFilters() {
    this.params = [];
    this.featuresFilters.forEach(feature => {
      feature.classList.remove(this.CLASSES.checked);
    });
    // reload stores
    this.loadStores();
  }

  filterCollection(filtersBox) {
    // check
    if (filtersBox === null) return false;
    // ctx
    let ctx = this;
    let collectionRadio = filtersBox.querySelectorAll(this.SELECTORS.filtersCollection);
    if (collectionRadio !== null) {
      collectionRadio.forEach(btn => {
        btn.addEventListener('change',() => {
          // reset filter
          this.params = [];
          // reset other filters style
          collectionRadio.forEach(b => {
            if (b !== btn) {
              b.parentElement.dataset.checked = 'false';
            }
          });
          // add filter
          if (btn.value !== '') {
            this.params.push(btn.value);
            btn.parentElement.dataset.checked = 'true';
          }
          // reload stores
          this.loadStores();
        });
      });
    }
  }

  manageResultsLayer(hide = false, clear = false) {
    // show search results
    if (!hide && !clear && this.searchResults.classList.contains(this.CLASSES.hidden)) {
      this.searchResults.classList.remove(this.CLASSES.hidden);
    }
    // close search results
    if (hide && !this.searchResults.classList.contains(this.CLASSES.hidden)) {
      this.searchResults.classList.add(this.CLASSES.hidden);
    }
    // clear input
    if (clear) this.searchResults.innerHTML = '';
  }

  updateSearchInput(position) {
    this.geocoder.geocode({location: position}).then(({results}) => {
      if (results.length) {
        results.forEach(address => {
          // get generic city address, like autosuggestions
          if (address.address_components[0].types[0] === 'locality') {
            this.inputSearch.value = address.formatted_address;
          }
        });
      }
    });
  }

  /**
   * Function to bind events related to this component
   */
  bindEvents() {
    let ctx = this;

    // if there is search input, proceed
    if (this.inputSearch) {
      const debouncedFunction = (event) => {
        ctx.onSearchInput(event, ctx);
      }
      this.inputSearch.addEventListener('keydown', (e) => (e.keyCode === 13 ? e.preventDefault() : '' ));
      this.inputSearch.addEventListener('keydown', _.debounce(debouncedFunction, 300));
    }

    // if there is clear button, proceed
    if (this.clearButton) {
      // add event listener to clear input search
      this.clearButton.addEventListener('click', () => {
        if (ctx.inputSearch) ctx.inputSearch.value = '';
        this.manageResultsLayer(true, true);
      });
    }

    // if there is search button, proceed
    if (this.searchButton) {
      this.searchButton.addEventListener('click', (e) => {
        // prevent default submit event
        e.preventDefault();
        // get geolocation from browser geolocation, if present
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
              };
              this.center = pos;
              // move map
              this.map.setCenter(pos);
              this.map.setZoom(10);
              // update search input
              this.updateSearchInput(pos);
              // load stores
              this.loadStores({
                lat: pos.lat,
                lng: pos.lng,
                listJson: true,
                withoutRadius: false
              });
            }
          ),
            () => {
              window.alert('Servizi di geolocalizzazione non disponibili')
            }
        }
      })
    }

    // if there are filters, proceed
    if (this.featuresFilters && this.featuresFilters.length) {
      // for each filter, add event listener
      this.featuresFilters.forEach(feature => {
        // add listener to wrapper
        feature.addEventListener('click', (event) => {
          event.stopPropagation();
          // toggle filter selection
          this.handleFilterSelection(feature);
        });
        // add listener also to children
        feature.querySelector(this.SELECTORS.filterLabel).addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          // toggle filter selection
          this.handleFilterSelection(feature);
        })
      })
    }

    // filters window
    if (this.filtersBtn !== null) {
      this.filtersBtn.forEach(btn => {
        btn.addEventListener('click', () => {
          let filtersBox = btn.closest(ctx.SELECTORS.filtersBox);
          if (filtersBox !== null) {
            // close if opened
            if (filtersBox.classList.contains(ctx.CLASSES.open)) {
              filtersBox.classList.remove(ctx.CLASSES.open);
              return;
            }
            // open window
            filtersBox.classList.add(ctx.CLASSES.open);
          }
        });
      });
    }

    // hide dropdown when click outside
    if (this.searchResults && this.inputSearchContainer) {
      document.addEventListener('click', event => {
        if (!this.inputSearchContainer.contains(event.target)) {
          this.manageResultsLayer(true, false);
        }
      })
    }
    // show dropdown when focus on input
    if (this.searchResults && this.inputSearch) {
      this.inputSearch.addEventListener('focus', () => {
        if (this.searchResults.children.length > 0) {
          this.manageResultsLayer(false, false);
        }
      })
    }

    this.filteringFunctions();
  }

  render() {
    super.render();

    // Load libraries
    this.loadLibraries().then(() => {
      // Init map
      this.initMap();
      // Bind events
      this.bindEvents();
    });
  }
}
